/* Clevergoods — per-product personalisation rules.
 *
 * Loaded by the "Personalisation rules" custom-liquid block in templates/product.json.
 * Lives in assets/ rather than inline because a large inline custom_liquid string
 * silently kills the whole product-information section server-side (see STATUS.md).
 *
 * Each product handle gets its own contract, matching what ShineOn expects:
 *
 *   their-tag, their-paw,   two lines,  "Engraving Line 1" / "Engraving Line 2", 20 chars
 *   their-heart              (ShineOn templates 1667 / 1677 / 258 all expect cf_1 + cf_2)
 *   their-ring, their-band  one line,   "Engraving Line", 25 chars, digits + spaces allowed
 *   everything else         one line,   "Their name", 10 letters only
 */
(function () {
  var handle = (location.pathname.split('/products/')[1] || '').split('?')[0];

  var mode = 'name';
  if (/^their-tag|^their-paw|^their-heart/.test(handle)) mode = 'two';
  else if (/^their-ring|^their-band/.test(handle)) mode = 'engraving';

  // The custom-property input is rendered by the theme's own block, which may not
  // be in the DOM yet when this runs. Poll briefly, then give up.
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    var input = document.querySelector('[name^=properties]');
    if (!input || input.tagName !== 'INPUT') {
      if (tries > 80) clearInterval(timer);
      return;
    }
    clearInterval(timer);
    if (mode === 'two') twoLines(input);
    else if (mode === 'engraving') oneEngravingLine(input);
    else theirName(input);
  }, 250);

  function counterEl() {
    return document.querySelector('.__character-count');
  }

  function hostOf(input) {
    return input.closest('.spacing-style') || input.parentElement.parentElement;
  }

  /* ---- default: "Their name", 10 letters, no spaces or digits ---- */
  function theirName(input) {
    var LIMIT = 10, MIN = 2;
    var counter = counterEl();
    input.setAttribute('maxlength', LIMIT);
    if (counter) counter.setAttribute('data-max', LIMIT);

    var guard = function () {
      var caret = null;
      try { caret = input.selectionStart; } catch (e) {}
      var clean = input.value.replace(/[^A-Za-z]/g, '');
      if (clean.length > LIMIT) clean = clean.slice(0, LIMIT);
      if (clean !== input.value) {
        var newCaret = null;
        if (caret !== null) {
          newCaret = input.value.slice(0, caret).replace(/[^A-Za-z]/g, '').length;
          if (newCaret > LIMIT) newCaret = LIMIT;
        }
        input.value = clean;
        if (newCaret !== null) {
          try { input.setSelectionRange(newCaret, newCaret); } catch (e) {}
        }
      }
      input.setAttribute('maxlength', LIMIT);
      if (counter) {
        counter.setAttribute('data-max', LIMIT);
        counter.textContent = input.value.length + '/' + LIMIT + ' characters used';
      }
      input.setCustomValidity(
        input.value.length > 0 && input.value.length < MIN
          ? 'Please use at least ' + MIN + ' letters.'
          : ''
      );
    };

    bind(input, guard);
    guard();
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ---- rings: one "Engraving Line", 25 chars, digits and spaces allowed ---- */
  function oneEngravingLine(input) {
    var LIMIT = 25;
    var BAD = /[^A-Za-z0-9 ♥❤.\/&=-]/g;
    var counter = counterEl();

    input.setAttribute('name', 'properties[Engraving Line]');
    input.setAttribute('maxlength', LIMIT);
    input.setAttribute('placeholder', 'Bailey 2011 - 2024');
    if (counter) counter.setAttribute('data-max', LIMIT);

    relabel(
      hostOf(input),
      'Engraving',
      'Up to 25 characters — letters, numbers, spaces and hearts all welcome. ' +
        "We engrave it exactly as you type it, so it's worth a second look."
    );

    var guard = function () {
      var caret = null;
      try { caret = input.selectionStart; } catch (e) {}
      var clean = input.value.replace(BAD, '');
      if (clean.length > LIMIT) clean = clean.slice(0, LIMIT);
      if (clean !== input.value) {
        var newCaret = null;
        if (caret !== null) {
          newCaret = input.value.slice(0, caret).replace(BAD, '').length;
          if (newCaret > LIMIT) newCaret = LIMIT;
        }
        input.value = clean;
        if (newCaret !== null) {
          try { input.setSelectionRange(newCaret, newCaret); } catch (e) {}
        }
      }
      input.setAttribute('maxlength', LIMIT);
      if (counter) {
        counter.setAttribute('data-max', LIMIT);
        counter.textContent = input.value.length + '/' + LIMIT + ' characters used';
      }
      input.setCustomValidity(
        input.value.trim().length < 1 ? 'Please add the engraving text.' : ''
      );
    };

    bind(input, guard);
    guard();
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ---- tag, bangle and heart: two lines of 20, at least one filled ---- */
  function twoLines(input) {
    var LIMIT = 20;
    var formId = input.getAttribute('form');
    var host = hostOf(input);

    // Retire the theme's own field so it can never submit alongside ours.
    input.disabled = true;
    input.required = false;
    input.removeAttribute('name');
    host.style.display = 'none';

    var wrap = document.createElement('div');
    wrap.style.margin = '0 0 12px';

    function makeLine(label, prop, placeholder) {
      var row = document.createElement('div');
      row.style.marginBottom = '10px';

      var el = document.createElement('label');
      el.textContent = label;
      el.style.display = 'block';
      el.style.marginBottom = '4px';
      el.style.fontSize = '0.875rem';

      var field = document.createElement('input');
      field.type = 'text';
      field.name = 'properties[' + prop + ']';
      field.maxLength = LIMIT;
      field.placeholder = placeholder;
      field.style.width = '100%';
      field.style.padding = '10px 12px';
      field.style.boxSizing = 'border-box';
      field.style.border = '1px solid currentColor';
      field.style.background = 'transparent';
      field.style.color = 'inherit';
      if (formId) field.setAttribute('form', formId);

      var count = document.createElement('div');
      count.style.fontSize = '0.75rem';
      count.style.opacity = '0.65';
      count.style.marginTop = '4px';
      count.textContent = '0/' + LIMIT + ' characters used';

      field.addEventListener('input', function () {
        count.textContent = field.value.length + '/' + LIMIT + ' characters used';
        sync();
      });

      row.appendChild(el);
      row.appendChild(field);
      row.appendChild(count);
      wrap.appendChild(row);
      return field;
    }

    var lineOne = makeLine('Line one', 'Engraving Line 1', 'Bailey');
    var lineTwo = makeLine('Line two (optional)', 'Engraving Line 2', '2011 - 2024');

    var note = document.createElement('div');
    note.style.fontSize = '0.8125rem';
    note.style.opacity = '0.7';
    note.textContent =
      'Up to 20 characters a line. We cut it exactly as you type it, so it is worth a second look.';
    wrap.appendChild(note);

    host.parentElement.insertBefore(wrap, host);

    function sync() {
      var filled = lineOne.value.trim().length > 0 || lineTwo.value.trim().length > 0;
      lineOne.setCustomValidity(filled ? '' : 'Add at least one line.');
    }
    lineOne.addEventListener('input', sync);
    lineTwo.addEventListener('input', sync);
    sync();
  }

  /* ---- helpers ---- */
  function bind(input, guard) {
    input.addEventListener('input', guard);
    input.addEventListener('change', guard);
    input.addEventListener('blur', guard);
    var formId = input.getAttribute('form');
    var form = formId ? document.getElementById(formId) : null;
    if (form) form.addEventListener('submit', guard, true);
  }

  // Swap the theme block's heading and helper copy.
  //
  // Target .__heading and .__description specifically. Do NOT touch
  // label.__character-label: it WRAPS span.__character-count, so setting its
  // textContent deletes the character counter. That bug shipped once already.
  function relabel(host, heading, description) {
    if (!host) return;
    var h = host.querySelector('.__heading');
    if (h) h.textContent = heading;
    var d = host.querySelector('.__description');
    if (d) d.textContent = description;
  }
})();
